<template>
  <v-app id="app">
    <router-view name="header" />
    <router-view />
    <router-view name="footer" />
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>
